import * as actionTypes from 'constants/ActionTypes';

const termEntities = (state = [], action) => {
    switch (action.type) {
        case actionTypes.GET_TERM_ENTITIES.REQUEST:
            return state;
        case actionTypes.GET_TERM_ENTITIES.SUCCESS:
            return {
                ...action.data,
            };
        case actionTypes.GET_TERM_ENTITIES.FAILURE:
            return state;

        default:
            return state;
    }
};

export default termEntities;



// WEBPACK FOOTER //
// ./app/reducers/termEntities.js